import React from "react"
import { formatFullDateTime } from "../../utils/format"

function GroupPendingInvitesPanel({ invites = [], isLoading = false, error = "" }) {
  return (
    <div className="bg-white/95 rounded-2xl border border-gray-200 shadow-md p-4">
      <h3 className="text-sm font-semibold text-gray-900 mb-2">Pending Invites</h3>

      {isLoading && <p className="text-xs text-gray-500">Loading pending invites...</p>}
      {!isLoading && !!error && <p className="text-xs text-red-600">{error}</p>}

      {!isLoading && !error && invites.length === 0 && (
        <p className="text-xs text-gray-500">No pending invites for this group.</p>
      )}

      {!isLoading && !error && invites.length > 0 && (
        <div className="space-y-2">
          {invites.map((inv) => (
            <div key={inv.id} className="border border-gray-100 rounded-xl p-3 bg-gray-50/70">
              <p className="text-sm font-medium text-gray-900">{inv?.invitee?.name || "Unknown user"}</p>
              <p className="text-xs text-gray-600">Phone: {inv?.invitee?.phone || "-"}</p>
              <p className="text-xs text-gray-500">Sent: {formatFullDateTime(inv.createdAt)}</p>
              {!!inv.message && <p className="text-xs text-gray-600 mt-1">"{inv.message}"</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default GroupPendingInvitesPanel
